import ApiClient from '@/api/ApiClient';

const client = new ApiClient('agency/useragencyrating');

class UserAgencyRatingApiAgency {
	static add (addUserAgencyRatingModel: IAddUserAgencyRatingModel) {
		return client.post<number>('', addUserAgencyRatingModel);
	}

	static update (updateUserAgencyRatingModel: IUpdateUserAgencyRatingModel) {
		return client.put<number>('', updateUserAgencyRatingModel);
	}
}

export default UserAgencyRatingApiAgency;
